import { ResponseModal } from "./responseModals";
import { ConfirmeModal } from "./responseModals/ConfirmeModal";
import { useRefundPOS } from "@/hooks/useRefundPOS";
import {
    RadioGroup,
    Stack,
    Radio,
    Text,
    Flex,
    Image,
    useDisclosure,
    Divider,
    Button,
} from "@chakra-ui/react";
import { Modal } from "barte-design-system";
import { useState } from "react";

export const RefundPOSModal = ({setReload, isDisabled, charge, isProcessingRefund}: {setReload: React.Dispatch<React.SetStateAction<number>> , isDisabled: boolean,charge : any, isProcessingRefund: boolean} ) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [openModal, setOpenModal] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [refundType, setRefundType] = useState("total");
    const [openResponseModal, setOpenResponseModal] = useState<boolean>(false)
    const [responseModal, setResponseModal] = useState<boolean>(false)
    const maxAmountRefund = charge?.value;
    return (
        <>
            <Flex flexDir="column" align="flex-start">
                {isProcessingRefund ? (
                    <Button
                        colorScheme="pink"
                        onClick={onOpen}
                        p="0"
                        m="0"
                        color={"red.danger"}
                        fontSize={"1rem"}
                        id="excluir_cobrança"
                        variant="ghost"
                        h="24px"
                        maxW="145px"
                        transition="filter .2s"
                        cursor="pointer"
                        isDisabled
                        _hover={
                            {
                                transition: "filter .2s",
                                filter: "brightness(.8)",
                                textDecoration: "underline",
                                color: "red.danger",
                            }
                        }
                    >
                        Processando estorno
                    </Button>
                ) : (
                    <Button
                        colorScheme="pink"
                        onClick={onOpen}
                        p="0"
                        m="0"
                        color={"red.danger"}
                        fontSize={"1rem"}
                        id="excluir_cobrança"
                        variant="ghost"
                        h="24px"
                        maxW="145px"
                        transition="filter .2s"
                        cursor="pointer"
                        isDisabled={isDisabled}
                        _hover={
                            {
                                transition: "filter .2s",
                                filter: "brightness(.8)",
                                textDecoration: "underline",
                                color: "red.danger",
                            }
                        }
                    >
                        Estornar cobrança
                    </Button>
                )}
            </Flex>
            <ConfirmeModal
                amount={maxAmountRefund}
                openModal={openModal}
                setOpenModal={setOpenModal}
                setResponseModal={setResponseModal}
                setOpenResponseModal={setOpenResponseModal}             
                setReload={setReload}
          
            />
            <ResponseModal
                openResponseModal={openResponseModal}
                setOpenResponseModal={setOpenResponseModal}
                setResponseModal={setResponseModal}
                responseModal={responseModal}
                setReload={setReload}
            />

            <Modal
                isOpen={isOpen}
                title="Como você deseja realizar esse estorno?"
                onClose={onClose}
                footer={{
                    primaryButton: {
                        children: "Continuar",
                        disabled: !isValid,
                        onClick: () => { setOpenModal(true); onClose(); },
                    },
                    secondaryButton: {
                        children: "Cancelar",
                        variant: "outline",
                        onClick: onClose,
                    },
                }}
            >
                <Flex w="100%" flexDir="column" gap="6px">
                    <RadioGroup defaultValue="total" value={refundType} onChange={setRefundType}>
                        <Stack direction="row" gap="0" mt={3}>
                            <Flex ml="0" w="236px" h="40px" p="5px 16px" cursor="pointer" color="#DF295D" onClick={() => setIsValid(true)} border="1px solid #DF295D">
                                <Radio colorScheme="pink" value="total">Total</Radio>
                            </Flex>
                        </Stack>
                    </RadioGroup>
                    <Text>Será estornado o valor de <b>R$ {maxAmountRefund.toFixed(2)}</b> correspondente a todo o valor disponível para estorno.</Text>
                </Flex>
            </Modal>
        </>
    );
};

